import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { rcsbaseurl } from "../../Appjs/api";
import { secureRcsBaseQuery } from "./secureRcsBaseQuery";

export const rcsTemplateApi = createApi({
  reducerPath: "rcsTemplateApi",
// Check in local apis org url
  baseQuery: fetchBaseQuery({
    baseUrl: rcsbaseurl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  // baseQuery: secureRcsBaseQuery,

  tagTypes: ["RcsTemplate", "RcsBots"],

  endpoints: (builder) => ({
    getRcsAgent: builder.query({
      query: () => "/rcs/get-all-rcs-agents",
      providesTags: ["RcsTemplate"],
    }),

    getRcscategory: builder.query({
      query: () => "/rcs/categories",
      providesTags: ["RcsTemplate"],
    }),

    getsuggestion: builder.query({
      query: () => "/rcs/get-action-button",
      providesTags: ["RcsTemplate"],
    }),

    postRcsTemplate: builder.mutation({
      query: (data) => ({
        url: "/rcs/create-template",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["RcsTemplate"],
    }),

    getRcsTemplateList: builder.query({
      query: ({ id, page, limit }) => ({
        url: `/rcs/templates-customer/${id}`,
        params: { page, limit },
      }),
      transformResponse: (response) => ({
        data: response.data,
        totalRecords: response.pagination?.totalRecords ?? 0,
        totalPages: response.pagination?.totalPages ?? 0,
        currentPage: response.pagination?.currentPage ?? 1,
      }),
      providesTags: ["RcsTemplate"],
    }),

    deleteRcsTemplate: builder.mutation({
      query: (id) => ({
        url: `/rcs/delete-template/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RcsTemplate"],
    }),

    getRcsTemplateView: builder.query({
      query: (id) => `/rcs/get-view-template-data/${id}`,
      providesTags: ["RcsTemplate"],
    }),

    getcategory: builder.query({
      query: () => "/rcs/getAllRcsBotTypes",
      providesTags: ["RcsTemplate"],
    }),

    getcategoryid: builder.query({
      query: (id) => `/rcs/customerBots/${id}`,
      providesTags: ["RcsTemplate"],
    }),

    // ✅ fixed (single query block)
    getcampaignlist: builder.query({
      query: ({ page = 1, limit = 25 } = {}) => ({
        url: "/upload/getRcsCampaignList",
        params: { page, limit },
      }),
      providesTags: ["RcsTemplate"],
    }),

    // getcamplaignlistbyid: builder.query({
    //   query: (bot_id) => `/rcs/templates-by?AgentName=${bot_id}`,
    //   providesTags: ["RcsTemplate"],
    // }),
    getcamplaignlistbyid: builder.query({
  query: (argument) => {
    // Preserve existing calls that pass one provider bot ID.
    if (typeof argument === "string") {
      return {
        url: "/rcs/templates-by",
        params: {
          AgentName: argument,
        },
      };
    }

    // New campaign selection: internal bot primary keys.
    return {
      url: "/rcs/templates-by",
      params: {
        selected_bot_ids: JSON.stringify(
          argument.selected_bot_ids,
        ),
      },
    };
  },
  providesTags: ["RcsTemplate"],
}),

    getcampaigndetailbyid: builder.query({
      query: ({ campaignId, page = 1, pagesize = 25 }) =>
        `/upload/campaign-details/${campaignId}?page=${page}&pagesize=${pagesize}`,
      providesTags: ["RcsTemplate"],
    }),

    postRcscampaign: builder.mutation({
      query: (formData) => ({
        url: "/upload/rcs-campaign",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["RcsTemplate"],
    }),

    postRcscampaignWithoutFile: builder.mutation({
      query: (payload) => ({
        url: "/upload/campaign-without-file",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["RcsTemplate"],
    }),

    getAllBotsList: builder.query({
      query: (id) => `/rcs/get-all-bots?customer_id=${id}`,
      providesTags: ["RcsBots"],
    }),

    getCampaignListByDate: builder.query({
      query: ({ startdate, enddate, page = 1, limit = 25 }) =>
        `/upload/campaign-list/date-range?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
    }),

    rcsflowreportcount: builder.query({
      query: (campaignflow_id) =>
        `/upload/campaigns/status-count?campaignflow_id=${campaignflow_id}`,
      providesTags: ["RcsTemplate"],
    }),

    rcsflowreportcounts: builder.query({
      query: ({ campaignflow_id, status,page,limit }) =>
        `/upload/campaigns/status-details?campaignflow_id=${campaignflow_id}&status=${status}&page=${page}&limit=${limit}`,
    }),
    rcsConsolidatedReport: builder.query({
      query: ({ startdate, enddate }) =>
        `/upload/get-rcs-consolidated-report?startdate=${startdate}&enddate=${enddate}`,
    }),
    rcsdeliveryreportdownload: builder.query({
      query: ({ startdate, enddate, page = 1, limit = 25 }) =>
        `/upload/download-campaign-list?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
    }),
    rcsdeliviryreportdownloadbycampaignid: builder.query({
      query: ({ campaign_id }) =>
        `/upload/download-rcs-campaign-reports?campaign_id=${campaign_id}`,
    }),
    getResellerRcsCampaignList: builder.query({
      query: ({ startdate, enddate, page = 1, limit = 25 }) =>
        `/upload/reseller-campaign-list/date-range?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
    }),
    getResellerRcsCampaignDetails: builder.query({
      query: ({ campaignId, page = 1, pagesize = 25 }) =>
        `/upload/reseller-campaign-details/${campaignId}?page=${page}&pagesize=${pagesize}`,
    }),
    // Add this new endpoint to your existing rcsTemplateApi
    rcsdeliveryreportdownloadzipopup: builder.query({
      query: ({ campaign_id }) => ({
        url: `/upload/download-campaign-reports/${campaign_id}`,
        responseHandler: (response) => response.blob(),
      }),
    }),
    rcsdeliveryreportdownloadzip: builder.query({
      query: ({ startdate, enddate, campaign_id }) => {
        let url = `/upload/download-campaign-reports-zip?startdate=${startdate}&enddate=${enddate}`;
        if (campaign_id) {
          url += `&campaign_id=${campaign_id}`;
        }
        return {
          url: url,
          method: "GET",
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
        };
      },
      transformResponse: (blob, meta, arg) => {
        const { startdate, enddate, campaign_id } = arg;
        let fileName;
        if (campaign_id) {
          fileName = `campaign_${campaign_id}_report_${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.zip`;
        } else {
          fileName = `rcs_report_${startdate}_to_${enddate}_${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.zip`;
        }
        return { blob, fileName };
      },
    }),
    getrcsclickreport: builder.query({
      query: ({ campaign_id, mobile_number, page = 1, limit = 25 }) =>
        `/upload/click-details/${campaign_id}/${mobile_number}?page=${page}&pageSize=${limit}`,
    }),
  getrcscampaiononlydata: builder.query({
  query: ({ campaign_id, page = 1, pagesize = 25, status }) => ({
    url: `/upload/campaign-data/${campaign_id}?page=${page}&pagesize=${pagesize}${status ? `&status=${status}` : ""}`,
   
  }),
  providesTags: ['RcsCampaignData'],
}),
    getrcsschedule: builder.query({
      query: ({ startdate, enddate, page = 1, limit = 25 }) =>
        `/upload/scheduled-rcs-campaigns?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
    }),
    rcsdashboardcount: builder.query({
      query: (startdate, enddate) => `/upload/rcs-dashboard-count?startdate=${startdate}&enddate=${enddate}`,
      
    }),
    rcscampaignwithjustsplit: builder.mutation({
      query: (payload) => ({
        url: "/upload/campaign/split",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["RcsTemplate"],
    }),
    rcspreview: builder.mutation({
      query: (payload) => ({
        url: "/upload/rcs-campaign-preview",
        method: "POST",
        body: payload,
      }),
    }),
    getrcspreviewcount: builder.query({
      query: ({ preview_id }) => `/upload/rcs-campaign-preview/${preview_id}`,
    }),
    getrcstemplateforevent: builder.query({
  query: ({ template_name }) => ({
    url: "/rcs/event-template/details",
    method: "GET",
    params: { template_name },   // RTK encodes this for you
    headers: {
      "x-api-key": "fabmediatech-rcs-template-api-key-123",
    },
  }),
}),
    getrcsdlrurl: builder.query({
      query:({page=1,limit=10})=>({
        url:`/webhook/customer-dlr-url?page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    postrcsdlrurl: builder.mutation({
      query:({rcspayload})=>({
        url:`/webhook/customer-dlr-url`,
        method:"POST",
        body:rcspayload
      })
    }),
    putrcsdlrurl: builder.mutation({
      query:({rcspayload,customerDlrUrl_id})=>({
        url:`/api/webhook/customer-dlr-url/${customerDlrUrl_id}`,
        method:"PUT",
        body:rcspayload
      })
    }),
    dltrcsdlrurl: builder.mutation({
      query:({customerDlrUrl_id}) =>({
        url:`/webhook/customer-dlr-url/${customerDlrUrl_id}`,
        method:"DELETE"
      })
    }),
    getApisendreport: builder.query({
      query:({startdate,enddate,page,limit}) => ({
        url:`/upload/getRcsApiRequestListByDate?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    getapicampaigndetails:builder.query({
      query:({apirequest_id,page,size})=>({
        url:`/upload/api-request-details/${apirequest_id}?page=${page}&pageSize=${size}`,
        meathod:"GET"
      })
    }),
    getrcsassociatebotids: builder.query({
      query:({rcs_template_id}) =>({
        url:`/rcs/template-associated-bots/${rcs_template_id}`,
        method:"GET"
      })
    }),
    getrcsresellercampaignlist: builder.query({
      query:({startdate,enddate,page,limit}) =>({
        url:`/upload/reseller-campaign-list/date-range?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    getrcsresellermisreport: builder.query({
      query:({month, year}) =>({
        url:`/upload/reseller-rcs-hourly-mis?month=${month}&year=${year}`,
        method:"GET"
      })
    }),
    getrcsresellerapireport: builder.query({
      query:({startdate,enddate,page,limit}) =>({
        url:`/upload/reseller-getRcsApiRequestListByDate?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    getrcsresellerschedulereport:builder.query({
      query:({startdate,enddate,page,limit})=>({
        url:`/upload/reseller-scheduled-rcs-campaigns?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    getrcsmisreport: builder.query({
      query:({month, year}) =>({
        url:`/upload/rcs-hourly-mis?month=${month}&year=${year}`,
        method:"GET"
      })
    })
  }),
});

//*rcs api hooks

export const {
  useGetCampaignListByDateQuery,
  useGetcampaigndetailbyidQuery,
  useGetAllBotsListQuery,
  useGetRcscategoryQuery,
  useGetRcsAgentQuery,
  useGetsuggestionQuery,
  usePostRcsTemplateMutation,
  useGetRcsTemplateListQuery,
  useDeleteRcsTemplateMutation,
  useGetRcsTemplateViewQuery,
  useGetcategoryQuery,
  useGetcategoryidQuery,
  useGetcampaignlistQuery,
  useGetcamplaignlistbyidQuery,
  usePostRcscampaignMutation,
  usePostRcscampaignWithoutFileMutation,
  useRcsflowreportcountQuery,
  useRcsflowreportcountsQuery,
  useLazyRcsflowreportcountsQuery,
  useRcsConsolidatedReportQuery,
  useRcsdeliveryreportdownloadQuery,
  useRcsdeliviryreportdownloadbycampaignidQuery,
  useLazyRcsdeliveryreportdownloadQuery,
  useLazyRcsdeliviryreportdownloadbycampaignidQuery,
  useGetResellerRcsCampaignListQuery,
  useGetResellerRcsCampaignDetailsQuery,
  useLazyRcsdeliveryreportdownloadzipQuery,
  useGetrcsclickreportQuery,
  useGetrcscampaiononlydataQuery,
  useGetrcsscheduleQuery,
  useLazyRcsdeliveryreportdownloadzipopupQuery,
  useRcsdashboardcountQuery,
  useRcscampaignwithjustsplitMutation,
  useRcspreviewMutation,
  useGetrcspreviewcountQuery,
  useGetrcstemplateforeventQuery,
  useGetrcsdlrurlQuery,
  usePostrcsdlrurlMutation,
  usePutrcsdlrurlMutation,
  useDltrcsdlrurlMutation,
  useGetapicampaigndetailsQuery,
  useGetApisendreportQuery,
  useGetrcsresellercampaignlistQuery,
  useGetrcsassociatebotidsQuery,
  useGetrcsresellermisreportQuery,
  useGetrcsresellerapireportQuery,
  useGetrcsresellerschedulereportQuery,
  useGetrcsmisreportQuery
} = rcsTemplateApi;
